<template>
  <v-container fluid id="NewWorkOrder">
    <!-- submitted dialog -->
    <v-dialog v-model="submitted" persistent width="500">
      <v-card>
        <v-card-text v-if="submitting">
          <h2 class="title mb-4 pt-4">Creating work order...</h2>
          <v-progress-linear
            indeterminate
            class="mb-0 mt-4"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else class="text-center">
          <h2 class="title mb-4 pt-4">Work Order successfully created!</h2>
          <v-btn color="primary" outlined to="/work-orders/orders"
            ><v-icon left>chevron_left</v-icon> Back to My Work Orders</v-btn
          >
          <div>
            <v-btn text @click="submitted = false" class="mt-4">close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" class="headline pl-0">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          to="/work-orders/orders"
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        New Work Order
      </v-col>
    </v-row>
    <!-- JOB DETAILS -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row class="mb-0">
                  <v-col xs="12">
                    <job-selector @jobSiteChange="jobSite = $event" />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col xs="12">
                    <v-text-field
                      v-model="client"
                      label="Client"
                      dense
                      prepend-icon="receipt"
                      required
                      :rules="[(v) => !!v || 'Client is required']"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col xs="12">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="dateCompleted"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs"
                          label="Date of Completion"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required
                          :rules="[(v) => !!v || 'Date required']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateCompleted"
                        scrollable
                        color="primary"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(dateCompleted)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- SERVICE & LABOR -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text>
              <h3 class="font-weight-bold mb-1">
                Labor & Service
              </h3>
              <v-container grid-list-xl class="pa-2">
                <v-row wrap>
                  <v-col cols="9" xs="9" class="pa-1">
                    <v-select
                      v-model="currentLabor"
                      :items="laborType"
                      hide-selected
                      item-text="type"
                      item-value="type"
                      placeholder="Select Labor"
                      return-object
                      filled
                      flat
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="3" xs="3" class="pa-1">
                    <v-btn
                      color="success"
                      class="elevation-0"
                      block
                      height="40"
                      @click="addLabor"
                      :disabled="!currentLabor"
                      >add</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>

              <v-simple-table
                dense
                class="order-details-table mt-0"
                v-if="labor.length"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Type</th>
                      <th class="text-left small-col">QTY</th>
                      <th class="text-left small-col">Hrs Per Labor</th>
                      <th width="20"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in labor" :key="index">
                      <td class="pa-1">
                        <v-text-field
                          dense
                          v-model="row.type"
                          hide-details
                          outlined
                          :readonly="true"
                        ></v-text-field>
                      </td>
                      <td class="pa-1">
                        <v-text-field
                          dense
                          type="number"
                          v-model.number="row.qty"
                          hide-details
                          outlined
                        ></v-text-field>
                      </td>
                      <td class="pa-1">
                        <v-text-field
                          dense
                          type="number"
                          v-model.number="row.hours"
                          hide-details
                          outlined
                        ></v-text-field>
                      </td>
                      <td class="pa-0 text-center">
                        <v-icon @click="labor.splice(index, 1)" color="grey"
                          >cancel</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-textarea
                outlined
                label="Describe Scope Completed"
                class="mt-4"
                v-model="scopeCompleted"
                required
                :rules="[(v) => !!v || 'Description is required']"
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- PARTS & MATERIAL -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text>
              <h3 class="font-weight-bold mb-1">
                Parts & Materials
              </h3>
              <v-container grid-list-xl class="pa-2">
                <v-row wrap>
                  <v-col cols="9" xs="9" class="pa-1">
                    <v-autocomplete
                      v-model="currentMaterial"
                      :search-input.sync="searchMaterial"
                      :items="materialList"
                      hide-no-data
                      hide-selected
                      item-text="title"
                      item-value="title"
                      placeholder="Search Tools"
                      prepend-inner-icon="search"
                      return-object
                      filled
                      flat
                      dense
                      hide-details
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3" xs="3" class="pa-1">
                    <v-btn
                      color="success"
                      class="elevation-0"
                      height="40"
                      block
                      @click="addMaterial"
                      :disabled="!currentMaterial"
                      >add</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>

              <v-simple-table
                dense
                class="order-details-table mt-0"
                v-if="partsMaterials.length"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left small-col">QTY</th>
                      <th width="20"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in partsMaterials" :key="index">
                      <td class="pa-1">
                        <v-text-field
                          dense
                          v-model="row.title"
                          hide-details
                          outlined
                          :readonly="!row.editable"
                        ></v-text-field>
                      </td>
                      <td class="pa-1">
                        <v-text-field
                          dense
                          type="number"
                          v-model.number="row.qty"
                          hide-details
                          outlined
                        ></v-text-field>
                      </td>
                      <td class="pa-0 text-center">
                        <v-icon
                          @click="partsMaterials.splice(index, 1)"
                          color="grey"
                          >cancel</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- DEBRIS REMOVAL -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text>
              <h3 class="font-weight-bold mb-1">
                Debris Removal
              </h3>
              <v-simple-table dense class="order-details-table mt-0">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left med-col">QTY</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="pa-1">
                        <v-text-field
                          dense
                          value="Yardage"
                          hide-details
                          outlined
                          :readonly="true"
                        ></v-text-field>
                      </td>
                      <td class="pa-1">
                        <v-text-field
                          dense
                          type="number"
                          v-model.number="debrisYardage"
                          hide-details
                          outlined
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- SIGNATURES - FOREMAN -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row no-gutters class="mb-4">
                  <v-col xs="12">
                    <h3 class="font-weight-bold mb-4">
                      FOREMAN Signature
                    </h3>
                    <p class="mb-1">
                      Foreman - Enter full name
                    </p>
                    <v-text-field
                      label="Full Name"
                      :value="`${this.user.firstName} ${this.user.lastName}`"
                      required
                      outlined
                      hide-details
                      class="mb-4"
                      :readonly="true"
                    ></v-text-field>
                    <p class="mb-1">
                      Foreman - Please sign below within yellow box
                    </p>
                    <vueSignature
                      ref="foremanSignature"
                      :sigOption="option"
                      :w="'100%'"
                      :h="'160px'"
                      style="border: 4px solid #fea000;border-radius: 5px;padding: 5px;"
                      class="mb-2"
                    ></vueSignature>
                    <v-btn
                      class="mr-2"
                      small
                      outlined
                      text
                      @click="clear('foremanSignature')"
                      >Clear</v-btn
                    >
                    <v-btn
                      class="mr-2"
                      small
                      outlined
                      text
                      @click="undo('foremanSignature')"
                      >Undo</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- SIGNATURES - CLIENT -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row no-gutters class="mb-4">
                  <v-col xs="12">
                    <h3 class="font-weight-bold mb-4">
                      CLIENT Signature
                      <v-btn
                        @click="showClientEmail = true"
                        v-if="!showClientEmail"
                        color="primary"
                        text
                        small
                        class="ml-3"
                        outlined
                        >Add email</v-btn
                      >
                    </h3>
                    <p class="mb-1">
                      Client - Enter full name
                    </p>
                    <v-text-field
                      label="Full Name"
                      v-model="clientPrintName"
                      outlined
                      hide-details
                      class="mb-4"
                      required
                      :rules="[(v) => !!v || 'Client Name required']"
                    ></v-text-field>
                    <p class="mb-1" v-if="showClientEmail">
                      Client - Email (Client will receive a copy)
                    </p>
                    <v-text-field
                      v-if="showClientEmail"
                      label="Email Address"
                      v-model="clientEmail"
                      type="email"
                      outlined
                      :rules="[
                        (v) =>
                          !v ||
                          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                            v
                          ) ||
                          'E-mail must be valid',
                      ]"
                      class="mb-4"
                    ></v-text-field>
                    <p class="mb-1">
                      Client - Please sign below within green box<br />
                      <strong class="black--text"
                        >* I agree that all work has been completed to my
                        satisfaction.</strong
                      >
                    </p>
                    <vueSignature
                      ref="clientSignature"
                      :sigOption="option"
                      :w="'100%'"
                      :h="'160px'"
                      style="border: 4px solid #4caf50;border-radius: 5px;padding: 5px;"
                      class="mb-2"
                    ></vueSignature>
                    <v-btn
                      class="mr-2"
                      small
                      outlined
                      text
                      @click="clear('clientSignature')"
                      >Clear</v-btn
                    >
                    <v-btn
                      class="mr-2"
                      small
                      outlined
                      text
                      @click="undo('clientSignature')"
                      >Undo</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row class="mt-4">
                  <v-col xs="12" sm="6">
                    <v-btn
                      class="mr-2"
                      :disabled="!valid || submitting"
                      block
                      color="primary"
                      @click="createWorkOrder"
                      >Submit Work Order</v-btn
                    >
                    <span class="red--text font-weight-bold" v-if="!valid"
                      >* Missing some required fields above.</span
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
          <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
          </v-snackbar>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import Vue from "vue";
import vueSignature from "vue-signature";
import JobSelector from "../components/JobSelector";
Vue.use(vueSignature);
export default {
  components: {
    vueSignature,
    JobSelector,
  },
  data() {
    return {
      valid: false,
      submitting: false,
      submitted: false,
      modal: false,
      snack: false,
      snackColor: "",
      snackText: "",
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      // form data
      jobSite: null,
      dateCompleted: null,
      client: "",
      clientEmail: "",
      showClientEmail: false,
      labor: [],
      partsMaterials: [],
      scopeCompleted: "",
      foremanPrintName: "",
      clientPrintName: "",
      currentMaterial: null,
      searchMaterial: "",
      currentLabor: null,
      debrisYardage: 0,
      laborType: [
        { type: "General Laborer", rate: 50 },
        { type: "General Laborer OT", rate: 75 },
        { type: "Fire-watch", rate: 52.5 },
        { type: "Fire-watch OT", rate: 78.75 },
        { type: "Torch Operator", rate: 80 },
        { type: "Torch Operator OT", rate: 120 },
        { type: "Carpenter", rate: 80 },
        { type: "Carpenter OT", rate: 120 },
        { type: "Foreman", rate: 75 },
        { type: "Foreman OT", rate: 112.5 },
        { type: "CDL Driver", rate: 90 },
        { type: "CDL Driver OT", rate: 135 },
        { type: "Site Superintendent", rate: 112.5 },
        { type: "Site Superintendent OT", rate: 168.75 },
        { type: "Project Manager", rate: 100 },
        { type: "Project Manager OT", rate: 150 },
        { type: "Project Executive", rate: 160 },
        { type: "Project Executive OT", rate: 240 },
        { type: "Fireproofing Foreman", rate: 70 },
        { type: "Fireproofing Sprayer", rate: 65 },
        { type: "Fireproofing Laborer", rate: 55 },
      ],
      materialList: [
        {
          title: "Demo Saw",
          unitPrice: 85,
        },
        {
          title: "Sawzall",
          unitPrice: 85,
        },
        {
          title: '12" metal sawzall blades',
          unitPrice: 3.1,
        },
        {
          title: '12" wood sawzall blades',
          unitPrice: 3.1,
        },
        {
          title: '9" metal sawzall blades',
          unitPrice: 2.65,
        },
        {
          title: '9" wood sawzall blades',
          unitPrice: 2.5,
        },
        {
          title: '6" metal sawzall blades',
          unitPrice: 2.45,
        },
        {
          title: '6" wood sawzall blades',
          unitPrice: 2.45,
        },
        {
          title: '14" concrete blades',
          unitPrice: 60,
        },
        {
          title: '14" metal blades',
          unitPrice: 7.5,
        },
        {
          title: '14" wood blades',
          unitPrice: 61,
        },
        {
          title: '12" concrete blades',
          unitPrice: 55,
        },
        {
          title: '12" wood blades',
          unitPrice: 36,
        },
        {
          title: "7-1/4 metal cutting blades",
          unitPrice: 8.25,
        },
        {
          title: "7-1/4 metal grinding blades",
          unitPrice: 8.92,
        },
        {
          title: "7-1/4 skil saw blades",
          unitPrice: 13.45,
        },
        {
          title: '4-1/2" metal cutting blades',
          unitPrice: 3.5,
        },
        {
          title: '4-1/2" metal grinding blades',
          unitPrice: 2.25,
        },
        {
          title: "Stihl chain saw chains 81",
          unitPrice: 25,
        },
        {
          title: "Stihl chain saw chains 72",
          unitPrice: 25,
        },
        {
          title: "spray paint",
          unitPrice: 8,
        },
        {
          title: "spray foam",
          unitPrice: 5.25,
        },
        {
          title: "spray adhesive",
          unitPrice: 27.5,
        },
        {
          title: "secondary filters w/metal ring for air machine",
          unitPrice: 65,
        },
        {
          title: "secondary filters for air machine",
          unitPrice: 28,
        },
        {
          title: "flex duct",
          unitPrice: 53,
        },
        {
          title: "safety vests",
          unitPrice: 11,
        },
        {
          title: "safety glasses",
          unitPrice: 3,
        },
        {
          title: "reflective tape",
          unitPrice: 109,
        },
        {
          title: "garbage bags",
          unitPrice: 19.65,
        },
        {
          title: "spray glue",
          unitPrice: 17,
        },
        {
          title: "ear plugs",
          unitPrice: 25,
        },
        {
          title: "dust mask",
          unitPrice: 10,
        },
        {
          title: "duct tape",
          unitPrice: 4.6,
        },
        {
          title: "danger tape",
          unitPrice: 4.1,
        },
        {
          title: "caution tape",
          unitPrice: 6.2,
        },
        {
          title: "blue tape",
          unitPrice: 7.5,
        },
        {
          title: "bar & chain oil",
          unitPrice: 10,
        },
        {
          title: "anit-freeze for jack hammer",
          unitPrice: 24.35,
        },
        {
          title: "air tool oil",
          unitPrice: 10.5,
        },
        {
          title: "#2 phillips bit",
          unitPrice: 1.5,
        },
        {
          title: "safety flag",
          unitPrice: 8,
        },
        {
          title: "combo lock",
          unitPrice: 16,
        },
        {
          title: "first aid kit 10 man",
          unitPrice: 25,
        },
        {
          title: "first aid kit 25 man",
          unitPrice: 33,
        },
        {
          title: "first aid kit 50 man",
          unitPrice: 64,
        },
        {
          title: "6' ladder",
          unitPrice: 105,
        },
        {
          title: "epoxy 200",
          unitPrice: 949.38,
        },
        {
          title: "epoxy 270",
          unitPrice: 904.63,
        },
        {
          title: "brooms(corn)",
          unitPrice: 9.99,
        },
        {
          title: "brooms",
          unitPrice: 10,
        },
        {
          title: "shovels",
          unitPrice: 34.99,
        },
        {
          title: "bars",
          unitPrice: 10,
        },
        {
          title: "dolly",
          unitPrice: 29.99,
        },
        {
          title: "mop and bucket",
          unitPrice: 15,
        },
        {
          title: "Compressor (Sigma Kaeser M50 185)",
          unitPrice: 185,
        },
        {
          title: "Compressor (Sigma Kaeser M50 375)",
          unitPrice: 300,
        },
        {
          title: "Rivet Buster",
          unitPrice: 70,
        },
        {
          title: "Chipping Gun",
          unitPrice: 75,
        },
        {
          title: "Rock Splitter",
          unitPrice: 900,
        },
        {
          title: "Rock drill",
          unitPrice: 60,
        },
        {
          title: "Clamps",
          unitPrice: 30,
        },
        {
          title: "90 Pound Jackhammer",
          unitPrice: 105,
        },
        {
          title: "JCB 8008 - 2000 Class",
          unitPrice: 200,
        },
        {
          title: "IHI15VX - 3500 Class",
          unitPrice: 400,
        },
        {
          title: "JCB8018 - 3500 Class",
          unitPrice: 400,
        },
        {
          title: "HYUNDAI R27 - 3500 Class",
          unitPrice: 400,
        },
        {
          title: "SHERPA W/ REG BKT",
          unitPrice: 350,
        },
        {
          title: "BROKK",
          unitPrice: 1000,
        },
        {
          title: "OTHER",
          editable: true,
          unitPrice: 0,
        },
        {
          title: "1 Mil Plastic",
          unitPrice: 45,
        },
        {
          title: "4 Mil Plastic",
          unitPrice: 58,
        },
        {
          title: "Tie Wire",
          unitPrice: 25,
        },
        {
          title: "Water Hoses",
          unitPrice: 75,
        },
        {
          title: "Mineral Wool",
          unitPrice: 60,
        },
        {
          title: "Intumescent Paint Sprayer",
          unitPrice: 20,
        },
        {
          title: "Mixer",
          unitPrice: 15,
        },
        {
          title: "Carousel/patch pump",
          unitPrice: 20,
        },
        {
          title: "S5",
          unitPrice: 50,
        },
        {
          title: "Accelerator pump",
          unitPrice: 15,
        },
        {
          title: "Heater approx 500,000 BTU",
          unitPrice: 50,
        },
        {
          title: "Lift 19ft",
          unitPrice: 35,
        },
        {
          title: "MK6 or equal",
          unitPrice: 30,
        },
        {
          title: "Z106 or equal",
          unitPrice: 35,
        },
        {
          title: "Z146 or equal",
          unitPrice: 42,
        },
        {
          title: "Bond Seal gallon",
          unitPrice: 65,
        },
        {
          title: "interior int paint gallon",
          unitPrice: 90,
        },
        {
          title: "Exterior int paint gallon",
          unitPrice: 120,
        },
        {
          title: "Primer gallon",
          unitPrice: 68,
        },
        {
          title: "Fiber Patch",
          unitPrice: 50,
        },
        {
          title: "Firestop gallon",
          unitPrice: 75,
        },
      ],
    };
  },
  computed: {
    ...mapState(["user", "jobSites"]),
    computedDateFormattedMomentjs() {
      return this.dateCompleted
        ? moment(this.dateCompleted).format("MM/DD/YYYY")
        : "";
    },
  },
  async created() {},
  methods: {
    async createWorkOrder() {
      try {
        if (!this.jobSite) {
          alert("You must select a job site.");
          return;
        }
        if (!this.$refs.form.validate()) {
          this.invalidMsg = true;
        }
        if (this.$refs.form.validate()) {
          if (this.$refs.foremanSignature.isEmpty()) {
            alert("Must include FOREMAN signature.");
            return;
          }
          if (this.$refs.clientSignature.isEmpty()) {
            alert("Must include CLIENT signature.");
            return;
          }
          if (!this.labor.length) {
            alert(
              "Please select labor and include hours. If no labor, select the 'General Laborer' option and add zero hours."
            );
            return;
          }

          this.submitted = true;
          this.submitting = true;
          await fb.db.runTransaction(async (transaction) => {
            // Get the metadata document and increment the count.
            const metaRef = fb.db.doc("metadata/workOrders");
            const metaData = (await transaction.get(metaRef)).data() || {};

            const number = metaData.count + 1;

            transaction.update(metaRef, {
              count: number,
            });

            // Update the order document
            const requestRef = fb.db
              .collection("workOrders")
              .doc(number.toString());

            var foremanSigRef = fb.signatureStorage.child(
              `work-order-signatures/foreman-${number.toString()}-${moment().unix()}.png`
            );
            var clientSigRef = fb.signatureStorage.child(
              `work-order-signatures/client-${number.toString()}-${moment().unix()}.png`
            );
            var foremanSignatureImg = this.$refs.foremanSignature.save();
            var clientSignatureImg = this.$refs.clientSignature.save();
            // Data URL string
            const imgSnapForeman = await foremanSigRef.putString(
              foremanSignatureImg,
              "data_url"
            );
            const imgSnapClient = await clientSigRef.putString(
              clientSignatureImg,
              "data_url"
            );
            const foremanImgUrl = await imgSnapForeman.ref.getDownloadURL();
            const clientImgUrl = await imgSnapClient.ref.getDownloadURL();

            transaction.set(requestRef, {
              jobSite: this.jobSite,
              client: this.client,
              dateCompleted: this.dateCompleted,
              dateCompletedFormatted: moment(this.dateCompleted).format(
                "MM/DD/YYYY"
              ),
              labor: this.labor,
              partsMaterials: this.partsMaterials,
              debrisYardage: this.debrisYardage,
              scopeCompleted: this.scopeCompleted,
              foremanPrintName: `${this.user.firstName} ${this.user.lastName}`,
              foremanSignatureImage: foremanImgUrl,
              clientSignatureImage: clientImgUrl,
              clientPrintName: this.clientPrintName,
              status: "open",
              orderedBy: this.user,
              orderDate: fb.timestamp,
              orderNumber: number.toString(),
              clientEmail: this.clientEmail || "",
            });
          });

          this.submitting = false;
          this.reset();
          this.$refs.form.resetValidation();
          this.debrisYardage = 0;
        }
      } catch (error) {
        this.submitting = false;
        this.submitted = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error Submitting Work Order!";
        alert("Error submitting work order.");
      }
    },
    clear(sigRef) {
      this.$refs[sigRef].clear();
    },
    undo(sigRef) {
      this.$refs[sigRef].undo();
    },
    reset() {
      // form reset
      this.client = "";
      this.labor = [];
      this.scopeCompleted = "";
      this.partsMaterials = [];
      this.dateCompleted = null;
      this.foremanPrintName = "";
      this.clientPrintName = "";
      this.showClientEmail = false;
      this.clientEmail = "";
      this.clear("foremanSignature");
      this.clear("clientSignature");
      this.debrisYardage = 0;
    },
    addMaterial() {
      const m = { ...this.currentMaterial, qty: 1 };
      this.partsMaterials.push(m);
      this.currentMaterial = null;
      this.searchMaterial = "";
    },
    addLabor() {
      const labor = { ...this.currentLabor, qty: 1, hours: 0 };
      this.labor.push(labor);
      this.currentLabor = null;
    },
  },
};
</script>

<style scoped>
.small-col {
  width: 60px;
}
@media (min-width: 600px) {
  .small-col {
    width: 90px;
  }
}
.med-col {
  width: 100px;
}
</style>
